import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { prepareMicrosoftAuthRequest } from "../../../util/microsoftSSOConfig";
import { SSOButton, BUTTON_WIDTH } from "./ssoButtonStyles";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: ${BUTTON_WIDTH}px;
  margin: 0;
`;

const StatusText = styled.div`
  font-size: 13px;
  text-align: center;
  color: #1a2a3a;
`;

const ErrorBox = styled(StatusText)`
  background-color: #fdecef;
  color: #8b1e2f;
  border: 1px solid #f5c0c9;
  padding: 8px 10px;
  border-radius: 8px;
`;

const MicrosoftGlyph = styled.span`
  width: 24px;
  height: 24px;
  display: inline-grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2px;
  border-radius: 4px;
  overflow: hidden;
`;

const GlyphSquare = styled.span`
  width: 100%;
  height: 100%;
  background-color: ${({ $tone }) => $tone};
`;

export default function MicrosoftSSOLogin() {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const startMicrosoftFlow = useCallback(async () => {
    setErrorMsg("");
    setLoading(true);
    try {
      const { authUrl, state } = await prepareMicrosoftAuthRequest();
      console.info("[MicrosoftSSO] Redirecting to Microsoft", {
        state,
        authUrlSnippet: authUrl?.slice(0, 120),
      });
      window.location.assign(authUrl);
    } catch (error) {
      console.error("[MicrosoftSSO] Unable to start Microsoft SSO", error);
      const message =
        error?.message === "missing_microsoft_config"
          ? "Microsoft SSO is not configured yet. Please contact your administrator."
          : "Unable to initiate Microsoft sign-in. Please try again later.";
      setErrorMsg(message);
      setLoading(false);
    }
  }, []);

  return (
    <Wrapper>
      <ButtonColumn>
        <SSOButton onClick={startMicrosoftFlow} disabled={loading}>
          <MicrosoftGlyph aria-hidden>
            <GlyphSquare $tone="#f35325" />
            <GlyphSquare $tone="#81bc06" />
            <GlyphSquare $tone="#05a6f0" />
            <GlyphSquare $tone="#ffba08" />
          </MicrosoftGlyph>
          <span>Continue with Microsoft</span>
        </SSOButton>
        {loading && <StatusText>Redirecting to Microsoft…</StatusText>}
        {errorMsg && <ErrorBox>{errorMsg}</ErrorBox>}
      </ButtonColumn>
    </Wrapper>
  );
}
